import clsx from 'clsx';
import React from 'react';

interface OtaIconProps {
    otaName?: string;
    size?: number;
    className?: string;
}

const OtaIcon: React.FC<OtaIconProps> = ({ otaName, size = 16, className }) => {
    if (!otaName) return null;

    // Map nama OTA ke path image
    const otaIcons: Record<string, string> = {
        BookingCom: '/icons/Booking.com_Icon_2022.svg',
        CTrip: '/icons/ctrip.png',
        Agoda: '/icons/Icon.jpeg',
        AirBNB: '/icons/Icon_airbnb.jpeg',
        Traveloka: '/icons/idW-_tGr1-_1749900443661.jpeg',
        TiketCom: '/icons/Tiket.com_(2017)_icon.svg',
        Expedia: '/icons/icons8-expedia-48.png',
        MGBedbank: '/icons/MgBedbankLogo.webp',
        Hostelworld: '/icons/hw-icon-rgb.png',
        Alaric: '/icons/alaric.png',
        OpenShopping: '/icons/OpenShopping.png',
        Goibibo: '/icons/goibibo.png',
        Bedshero: '/icons/bedshero_icon.png'
    };

    const iconSrc = otaIcons[otaName];

    if (!iconSrc) return null; // Kalau tidak ditemukan icon, jangan render apa-apa

    return (
        <img
            src={iconSrc}
            alt={`${otaName} Icon`}
            width={size}
            height={size}
            className={clsx(className ? className : 'me-1')}
        />
    );
};

export default OtaIcon;
